import {
    Sheet,
    SheetContent,
    SheetHeader,
    SheetTitle,
    SheetDescription,
} from "../../components/ui/sheet";

const NDA_PARAGRAPHS = [
    "This Non-Disclosure Agreement (the \"Agreement\") governs the review of confidential portfolio materials presented by Advanced Connected Technologies (\"ACT\") and accessed via this private area of actluxe.net. By acknowledging this Agreement, you (the \"Recipient\") represent that you are authorized to receive such material and will treat it in strict confidence.",
    "Recipient agrees that all photographic, architectural, technical, and narrative materials accessible via this portal — including project names, locations, system specifications, schematic plans, client identifiers, and partner references — are proprietary to ACT and its principals, and are disclosed solely for the purpose of evaluating a potential engagement.",
    "Recipient shall not reproduce, distribute, publish, or disclose any such material to any third party without the prior written consent of ACT and, where applicable, the subject principal. Recipient shall take reasonable precautions to prevent unauthorized access, including but not limited to screen capture, photography, and forwarding of credentials or session artifacts.",
    "This Agreement remains in effect for a period of seven (7) years from the date of acknowledgment. Any breach may entitle ACT and the subject principal to injunctive relief in addition to any other available remedies. This Agreement is governed by the laws of the Commonwealth of Massachusetts without regard to conflicts-of-laws principles.",
];

export default function NDAModal({ open, onOpenChange }) {
    return (
        <Sheet open={open} onOpenChange={onOpenChange}>
            <SheetContent
                side="right"
                className="!bg-[#0B0B0C] !text-[#F3EFE7] !border-l-[rgba(201,168,106,0.3)] w-full sm:max-w-xl p-0 flex flex-col"
                data-testid="nda-modal"
            >
                <SheetHeader className="px-8 py-6 border-b border-[rgba(201,168,106,0.3)] text-left space-y-2 shrink-0 bg-[#15161A]">
                    <span className="text-[10.5px] tracking-[0.32em] uppercase text-[#C9A86A]">
                        Non-Disclosure Agreement
                    </span>
                    <SheetTitle className="font-serif text-2xl md:text-3xl text-[#F3EFE7]">
                        Terms of Access
                    </SheetTitle>
                    <SheetDescription className="text-[11px] tracking-[0.22em] uppercase text-[#9A958A]">
                        Private Portfolio · Advanced Connected Technologies
                    </SheetDescription>
                </SheetHeader>
                <div className="flex-1 overflow-y-auto px-8 py-8 space-y-5 text-[#F3EFE7] text-[14.5px] leading-[1.85]">
                    {NDA_PARAGRAPHS.map((p, i) => (
                        <p key={p.slice(0, 40)} className={i === 0 ? "" : "text-[#C9C5BC]"}>
                            {p}
                        </p>
                    ))}
                    <div className="pt-4 border-t border-[rgba(201,168,106,0.12)]">
                        <p className="text-[12px] text-[#6e6a62] italic font-serif">
                            For questions regarding this Agreement, please
                            contact the concierge at
                            concierge@actluxe.net.
                        </p>
                    </div>
                </div>
            </SheetContent>
        </Sheet>
    );
}
